
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help-centre/tutorials",
      function () {
        return require("private-next-pages/help-centre/tutorials/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help-centre/tutorials"])
      });
    }
  